import { useDispatch, useSelector, useStore } from 'react-redux';
import { AppDispatch, AppStore } from '../store/store';
import { IRootReducer } from '../store/rootReducers';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<IRootReducer>();
export const useAppStore = useStore.withTypes<AppStore>();
